/**
 * Codmonサイドメニューグループディレクティブ
 *
 * @description
 * このディレクティブは、サイドメニュー内でメニュー項目をグループ化するコンテナコンポーネントを提供します。
 * グループ名を表示し、内部に複数のメニューアイテムを含めることができます。
 *
 * @example
 * // 基本的な使用方法
 * <codmon-sidemenu-group name="デイリーボード">
 *   <codmon-sidemenu-item>食事チェック</codmon-sidemenu-item>
 *   <codmon-sidemenu-item>出欠確認</codmon-sidemenu-item>
 * </codmon-sidemenu-group>
 *
 * @example
 * // 園児台帳グループ
 * <codmon-sidemenu-group name="園児台帳">
 *   <codmon-sidemenu-item>園児管理</codmon-sidemenu-item>
 *   <codmon-sidemenu-item>発達記録</codmon-sidemenu-item>
 * </codmon-sidemenu-group>
 *
 * @property {string} name - グループ名として表示するテキスト
 */
angular.module('inspinia').directive('codmonSidemenuGroup', () => {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    scope: {
      name: '@',
    },
    templateUrl: `/manage/src/view/directive/codmon-ui/codmon_sidemenu_group.html?${new Date().getTime()}`,
  };
});
